import { axios } from "../config";

function fetchInstitutionSummary() {
  return axios.get("/api/v1/class/get-institution-overview");
}
function createRoutine(data) {
  return axios.post("api/v1/class/schedule", data);
}

function fetchRoutine(data) {
  return axios.get("/api/v1/class/schedules", {
    params: data,
  });
}
function fetchRoutineByRoutineId(id) {
  return axios.get(`/api/v1/class/schedules`, {
    params: { routine_id: id },
  });
}

function fetchAcademicYear(data) {
  return axios.get("/api/v1/academic-years", {
    params: data,
  });
}

function createClassroom(data) {
  return axios.post("api/v1/classrooms/bulk", data);
}

function updateClassroom(classroomId, data) {
  return axios.put(`api/v1/classrooms/${classroomId}`, data);
}

function updateBulkClassroom(data) {
  return axios.put("api/v1/classrooms/bulk", data);
}

function deleteClassroom(classroomId) {
  return axios.delete(`api/v1/classrooms/${classroomId}`);
}
function deleteClass(classroomId) {
  return axios.delete(`api/v1/class/${classroomId}`);
}

function editRoutine(id, data) {
  return axios.put(`api/v1/class/schedule/${id}`, data);
}
function deleteRoutine(id) {
  return axios.delete(`api/v1/class/schedule/${id}`);
}
function uploadCsvFile(file) {
  return axios.post("api/v1/class/import-schedules", file, {
    headers: {
      "content-Type": "form-data",
    },
  });
}
function fetchStudentsAcademicYear(data) {
  return axios.get("/api/v1/academic-years/student-history", {
    params: data,
  });
}

export {
  uploadCsvFile,
  fetchInstitutionSummary,
  createRoutine,
  fetchRoutine,
  fetchAcademicYear,
  createClassroom,
  updateClassroom,
  updateBulkClassroom,
  deleteClassroom,
  editRoutine,
  deleteRoutine,
  fetchRoutineByRoutineId,
  deleteClass,
  fetchStudentsAcademicYear,
};
